import Logger, {LOG_LEVELS} from '../utils/logger';
import FileSaver from 'file-saver';
import _ from 'lodash';

export const MODULE_NAME = 'MERGE_XML_FILES_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
const NAME_SPACE ="ds";
const IT_xmlTraversalPath = `/${NAME_SPACE}:Fornitura/${NAME_SPACE}:Comunicazione/${NAME_SPACE}:DatiContabili`;
const IT_xmlMergeNodePath = `${IT_xmlTraversalPath}/${NAME_SPACE}:Modulo`;
let xmlEncoding = "";
let xmlInputEncoding ="";
let xmlStandalone ="";

function getNodeToInsertAfter(xml){
    let result = null;
    let nodeList = selectNodesUsingXmlPath(IT_xmlMergeNodePath,xml);
    if (nodeList && nodeList.length > 0) 
    {
        result = nodeList[0].parentNode;
     }
    return result ;
}
function orderMergedNodesWithSequece(xmlDoc){
    let masterFileNode = selectNodesUsingXmlPath(IT_xmlTraversalPath,xmlDoc);
    let masterFileNodeWithOrder = selectNodesUsingXmlPath(IT_xmlTraversalPath,xmlDoc);
    if(masterFileNodeWithOrder &&
       masterFileNodeWithOrder.length > 0 && 
       masterFileNodeWithOrder[0].getElementsByTagName('Modulo') &&
       masterFileNodeWithOrder[0].getElementsByTagName('Modulo').length > 0
       ){
        for(let i = 0 ; i < masterFileNodeWithOrder[0].getElementsByTagName('Modulo').length ; i++){

            if( masterFileNodeWithOrder[0].getElementsByTagName('Modulo')[i].getElementsByTagName('NumeroModulo') &&
                masterFileNodeWithOrder[0].getElementsByTagName('Modulo')[i].getElementsByTagName('NumeroModulo').length > 0 
            ){
                masterFileNodeWithOrder[0].getElementsByTagName('Modulo')[i].getElementsByTagName('NumeroModulo')[0].innerHTML = i + 1;
            }
        }
        xmlDoc = replaceNodeOfMasterFile(xmlDoc,masterFileNode[0],masterFileNodeWithOrder[0])
    }
    return xmlDoc;
}
function replaceNodeOfMasterFile(masterXmlDoc,masterFileNode,updatedNode){
    masterXmlDoc.getElementsByTagName("Fornitura")[0]
                    .getElementsByTagName("Comunicazione")[0]
                    .replaceChild(updatedNode,masterFileNode);

    return masterXmlDoc;
}
function selectNodesUsingXmlPath(nodepath, xml)
	{
		let resolver = null;
		let nodes = null;
		let arrayNodes =[];
		let ns = xml.children[0].getAttribute("xmlns");
		if(ns){
			resolver = function(prefix){
				if(ns && prefix === NAME_SPACE){
					return ns;
				}else{
					return null;
				}
			}
			nodes = xml.evaluate(nodepath, xml, resolver, XPathResult.ANY_TYPE, null);
		}else{
			nodes = xml.evaluate(nodepath.split(`${NAME_SPACE}:`).join(""), xml, null, XPathResult.ANY_TYPE, null);
		}

		if(nodes){
			let result = nodes.iterateNext();
			if(result){
				while (result) {
					arrayNodes.push(result);
					result = nodes.iterateNext();
				} 
			}
		}
		return arrayNodes;
	}

function updateNodesToMasterFile(masterXmlDoc,nodeList,nodeToInsertAfter){
    for(let i=0;i< nodeList.length;i++){
        nodeToInsertAfter.appendChild(nodeList[i]);
    }
    let masterFileNode = selectNodesUsingXmlPath(IT_xmlTraversalPath,masterXmlDoc);
    
    if(masterFileNode && masterFileNode.length > 0){
        masterXmlDoc = replaceNodeOfMasterFile(masterXmlDoc,masterFileNode[0],nodeToInsertAfter)
    }

    return masterXmlDoc;
}
function mergeFiles(filesInfo,fileListStringBuffer){
    let loopCounter = 0;
    let parser = new DOMParser();
    let masterXmlDoc ;
    let nodeToInsertAfter;
    _.each(filesInfo,function(rec){
        _.each(fileListStringBuffer,function(row){
            if(rec.index === row.index){
                if (loopCounter === 0){
                    masterXmlDoc = parser.parseFromString(row.fileString,"text/xml")
                    nodeToInsertAfter = getNodeToInsertAfter(masterXmlDoc);
                    if(masterXmlDoc){
                        xmlEncoding = masterXmlDoc.xmlEncoding ;
                        xmlInputEncoding = masterXmlDoc.inputEncoding ;
                        xmlStandalone = masterXmlDoc.xmlStandalone ;
                    }
                }else{
                    if(nodeToInsertAfter){
                        let xmlDoc = parser.parseFromString(row.fileString,"text/xml");
                        if(xmlDoc && xmlDoc.hasChildNodes()){
                            let nodeList = selectNodesUsingXmlPath(IT_xmlMergeNodePath,xmlDoc);
                            if(nodeList && nodeList.length > 0){
                                masterXmlDoc = updateNodesToMasterFile(masterXmlDoc,nodeList,nodeToInsertAfter);
                            }
                        }
                        masterXmlDoc = orderMergedNodesWithSequece(masterXmlDoc);
                    }
                }
                loopCounter = loopCounter + 1;
            }
        },this)
    },this)
    return masterXmlDoc;
  }

  function getMergeResultFileName(filesInfo){
    let fileName = _.sortBy(filesInfo, "index")[0].fileName ;
    let extension = fileName.split('.').pop();
    return `${fileName.split('.')[0]}_merged.${extension}`;
    }
export const API = {
    getMergedFile: function(filesInfo,fileListStringBuffer) {
        let xmlDoc = mergeFiles(filesInfo,fileListStringBuffer);
        if(xmlDoc){
            let xmlString = (new XMLSerializer()).serializeToString(xmlDoc);
            xmlString = xmlString.replace(' encoding="'+ xmlInputEncoding+'"',"");
            xmlString = xmlString.replace(' encoding="'+ xmlEncoding+'"',"");
            xmlString = xmlString.replace(' standalone="'+ xmlStandalone+'"',"");
            let blobObj = new Blob([xmlString],{ type: 'text/plain' });  
			FileSaver.saveAs(blobObj, getMergeResultFileName(filesInfo));
		}
    },
};

export default API;
